import Button from ".";

export default function LoadingButton() {
  return <Button className="btn btn-dark" isBlock disabled isLoading></Button>;
}
